// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
};
export const ns = "/company";
export const customerDomain = "http://localhost:8100";
export const imageDomain = "http://localhost:7060"; // for uploading of image only

// NGROK - url will always expire in 24hours after creation.
// export const domainRaw = "https://8ca7-165-173-12-238.ap.ngrok.io";

// export const domainRaw = "http://localhost:7060";
export const domainRaw = "https://internal-services.uat.tribox.me/tripos/v1";

export const domain = `${domainRaw}${ns}`;
